import React from "react";
import WeAllTeamConversation from "@/components/weAllTeam/WeAllTeamConversation";
import { breadcrumb_key } from "@/constants/translation/common.translation";
import { weAllTeam } from "@/libs/routes";

/**
 * WeAll Team Messages > Conversation: full history and reply.
 */
const WeAllTeamConversationPage = () => <WeAllTeamConversation />;

WeAllTeamConversationPage.breadCrumbArray = [
  {
    name: breadcrumb_key.weAllTeam.inbox,
    pathname: weAllTeam.inbox,
    active: false,
  },
  {
    name: breadcrumb_key.weAllTeam.conversation,
    pathname: "",
    active: true,
  },
];

export default WeAllTeamConversationPage;
